module.exports = __webpack_public_path__ + "static/media/sherlockholmesparrot.9bf7677c.gif";